import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  TASK: {
    LOAD_MORE: (query) => ({ query }),
    API: {
      LOAD_MORE: apiResourceActionCreator('completedTasks')
    }
  }
})

export const apiAction = (authToken, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}/completed${endpointQuery(query)}`, authToken, actions.task.api.loadMore);

function* loadMore(action) {
  const authToken = yield select(authTokenSelector);

  yield put(apiAction(authToken, action.payload.query));
}

const configuration = {
  name: 'loadMore',
  action: actions,
  sagas: loadMore,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      completedTasks: state.completedTasks.concat(action.payload.completedTasks),
      isFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/loadMore.js